import { apiSlice } from '../../api/apiSlice';

export const publicAssignmentApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllPublicAssignments: builder.mutation({
      query: (options) => ({
        url: `PublicAssignment/${options.skip}/${options.take}`,
        method: 'POST',
        credentials: 'include',
        body: options.body
      })
    }),
    getPublicAssignmentInfo: builder.mutation({
      query: (options) => ({
        url: `PublicAssignment/${options.assignmentId}/AssignmentInfo`,
        method: 'GET',
        credentials: 'include'
      })
    })
  })
});

export const {
  useGetAllPublicAssignmentsMutation,
  useGetPublicAssignmentInfoMutation
} = publicAssignmentApi;